import {
  fetchDELETE,
  fetchGET,
  fetchPOST,
  fetchPUT,
} from "../utils/handler_http";
import { encoJSON, encoURI, encoUriJson } from "../utils/handler_validations";
import { getFileSendDB } from "../utils/handler_files";

const getDataCreateTemplate = () => ({
  user: { name: "", lastName: "", email: "", tel: "" },
  vehicle: {
    model: "",
    year: "",
    airbags: "",
    abs: "",
    color: "",
    plates: "",
    economicNumber: "",
  },
});

const getUpdateDriverTemplate = () => ({
  user: { id: 0, name: "", lastName: "" },
  vehicle: {
    model: "",
    year: 0,
    airbags: 0,
    abs: false,
    color: "",
    plates: "",
    economicNumber: "",
  },
});

/**
 * Obtener la data de un driver de la lista
 */
export const getDriverTemplate = () => ({
  id: 0,
  fullName: "",
  profileImg: "",
  tel: "",
  enabled: false,
});

export const FILE_TYPE = {
  FRONT_PHOTO: "FRONT_PHOTO",
  BACK_PHOTO: "BACK_PHOTO",
  LEFT_PHOTO: "LEFT_PHOTO",
  RIGHT_PHOTO: "RIGHT_PHOTO",
  INE: "INE",
  DRIVER_LICENCE: "DRIVER_LICENCE",
  CRIMINAL_LETTER: "CRIMINAL_LETTER",
  CIRCULATION_CARD: "CIRCULATION_CARD",
  CONTRACT_REQUEST: "CONTRACT_REQUEST",
  INSURENCE_POLICY: "INSURENCE_POLICY",
  ADDRESS: "ADDRESS",
  PROFILE_IMG: "PROFILE_IMG",
  VEHICLE_CARD_CONSTANCY: "VEHICLE_CARD_CONSTANCY",
};

/**
 * Crear un nuevo registro de usuario conductor
 */
export const create = async (data = getDataCreateTemplate(), jwt = "") => {
  data.vehicle.color = data.vehicle.color.toUpperCase();
  const paramsBody = {
    name: encoURI(data.user.name),
    lastName: encoURI(data.user.lastName),
    tel: encoURI(data.user.tel),
    email: encoURI(data.user.email),
    vehicleModel: encoURI(data.vehicle.model),
    vehicleYear: encoJSON(data.vehicle.year),
    vehicleAirbags: encoJSON(data.vehicle.airbags),
    vehicleABS: encoJSON(data.vehicle.abs),
    vehicleColor: encoURI(data.vehicle.color),
    vehiclePlates: encoURI(data.vehicle.plates),
    vehicleEconomicNumber: encoURI(data.vehicle.economicNumber),
    curp: encoURI(data.curp || data.vehicle.curp || ""),
    vehicleSerialNumber: encoURI(data.vehicleSerialNumber || data.vehicle.vehicleSerialNumber || ""),
    allowsTrips: encoJSON(data.allowsTrips !== undefined ? data.allowsTrips : true),
    allowsShipments: encoJSON(data.allowsShipments !== undefined ? data.allowsShipments : true),
  };
  console.log(paramsBody);
  const response = await fetchPOST(
    process.env.REACT_APP_DRIVER_ENDPOINT,
    paramsBody,
    { Authorization: jwt }
  );
  return response;
};

/**
 * Actualizar un registro de usuario conductor
 */
export const updateDriver = async (
  data = getUpdateDriverTemplate(),
  jwt = ""
) => {
  const paramsBody = {
    driverId: encoJSON(data.user.id),
    name: encoURI(data.user.name),
    lastName: encoURI(data.user.lastName),
    vehicleModel: encoURI(data.vehicle.model),
    vehicleYear: encoJSON(data.vehicle.year),
    vehicleAirbags: encoJSON(data.vehicle.airbags),
    vehicleABS: encoJSON(data.vehicle.abs),
    vehicleColor: encoURI(data.vehicle.color),
    vehiclePlates: encoURI(data.vehicle.plates),
    vehicleEconomicNumber: encoURI(data.vehicle.economicNumber),
    curp: encoURI(data.curp || data.vehicle.curp || ""),
    vehicleSerialNumber: encoURI(data.vehicleSerialNumber || data.vehicle.vehicleSerialNumber || ""),
    allowsTrips: encoJSON(data.allowsTrips !== undefined ? data.allowsTrips : true),
    allowsShipments: encoJSON(data.allowsShipments !== undefined ? data.allowsShipments : true),
  };
  const response = await fetchPUT(
    process.env.REACT_APP_DRIVER_ENDPOINT,
    paramsBody,
    { Authorization: jwt }
  );
  return response;
};

/**
 * Comprobar si el CURP o el VIN ya existen en otro conductor
 */
export const checkDuplicate = async ({ curp = "", vehicleSerialNumber = "", driverId = 0 }, jwt = "") => {
  const baseUrl = getBaseUrl();
  const paramsBody = {
    curp: encoURI(curp),
    vehicleSerialNumber: encoURI(vehicleSerialNumber),
    driverId: encoJSON(driverId),
  };
  const response = await fetchPOST(
    `${baseUrl}check-driver-duplicate`,
    paramsBody,
    { Authorization: jwt }
  );
  return response;
};

/**
 * Actualizar un archivo del conductor
 */
export const updateFile = async (
  driverId = 0,
  updateType = "",
  file = getFileSendDB(),
  jwt = ""
) => {
  const fileDB = { fullBase64: file.fullBase64, ext: file.ext };
  const paramsBody = {
    driverId: encoJSON(driverId),
    updateType: encoURI(updateType),
    file: encoUriJson(fileDB),
  };
  const resp = await fetchPUT(
    process.env.REACT_APP_DRIVER_FILE_ENDPOINT,
    paramsBody,
    { Authorization: jwt }
  );
  return resp;
};

/**
 * Eliminar un archivo del conductor
 */
export const deleteFile = async (driverId = 0, deleteType = "", jwt = "") => {
  const paramsBody = {
    driverId: encoJSON(driverId),
    deleteType: encoURI(deleteType),
  };
  const resp = await fetchDELETE(
    process.env.REACT_APP_DRIVER_FILE_ENDPOINT,
    paramsBody,
    { Authorization: jwt }
  );
  return resp;
};

/**
 * Obtener la lista de drivers filtrada por nombre, apellido o tel
 */
export const getListDrivers = async (filterValue = "", jwt = "") => {
  const paramsQuery = {
    filterValue: encoURI(filterValue),
  };
  const response = await fetchGET(
    process.env.REACT_APP_DRIVERS_LIST_ENDPOINT,
    paramsQuery,
    { Authorization: jwt }
  );
  console.log(response);
  return response;
};

/**
 * Reenviar la contraseña temporal de un conductor
 */
export const resendTempPassword = async (tel = "") => {
  const paramsBody = { tel };
  const response = await fetchPOST(
    process.env.REACT_APP_DRIVER_RESEND_TEMP_PASSWORD_ENDPOINT,
    paramsBody
  );
  return response;
};

const getBaseUrl = () => {
  const listEndpoint = process.env.REACT_APP_DRIVERS_LIST_ENDPOINT || "";
  return listEndpoint.replace("admin-read-drivers-list", "");
};

/**
 * Obtener la lista de cupones pendientes de pago para un conductor
 */
export const getDriverUnpaidCoupons = async (driverId = 0, jwt = "") => {
  const baseUrl = getBaseUrl();
  const paramsQuery = {
    driverId: encoURI(driverId),
  };
  const response = await fetchGET(
    `${baseUrl}admin-read-driver-unpaid-coupons`,
    paramsQuery,
    { Authorization: jwt }
  );
  return response;
};

/**
 * Pagar saldo a favor (general o parcial) de un conductor
 */
export const payDriverBalance = async (driverId = 0, amount = 0, comment = "", jwt = "") => {
  const baseUrl = getBaseUrl();
  const paramsBody = {
    driverId: encoJSON(driverId),
    amount: encoJSON(amount),
    comment: encoURI(comment),
  };
  const response = await fetchPOST(
    `${baseUrl}admin-pay-driver-balance`,
    paramsBody,
    { Authorization: jwt }
  );
  return response;
};
